export enum SelectLocationConfiguration {
  AddLocation = 'AddLocation',
  SetProximityToolStartLocation = 'SetProximityToolStartLocation',
  SetPlacesToolStartLocation = 'SetPlacesToolStartLocation',
}

export type SelectLocationState = Readonly<{
  active: boolean;
  isAddressLookupLoading?: boolean;
  configuration?: SelectLocationConfiguration;
}>;
